module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (I18n.t('uploader.product_tagging_search.no_results.header')) { ;
__p += '\n  <b>\n    ' +
((__t = ( I18n.t('uploader.product_tagging_search.no_results.header') )) == null ? '' : __t) +
'\n  </b>\n';
 } ;
__p += '\n<span>\n  ' +
((__t = ( I18n.t('uploader.product_tagging_search.no_results.help_text') )) == null ? '' : __t) +
'\n</span>\n';

}
return __p
}